import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ValidationMessageComponent } from '../../../../shared/components/validation-message/validation-message.component';
import { CaptchaComponent } from '../../../../shared/components/captcha/captcha.component';
import { MiddlewareService } from '../../../../core/services/middleware.service';
import { EncryptionService } from '../../../../core/services/encryption.service';
import { CommonService } from '../../../../core/services/common.service';
import { ModalService } from '../../../../core/services/modal.service';
import { ApiResponse } from '../../../../core/enums/api-response.enum';
import { ModalType } from '../../../../core/enums/modal-type.enum';
import { globalDatas } from '../../../../../assets/data/globals';
import { apiURL } from '../../../../../assets/data/api-url';
import { RouteType } from '../../../../core/enums/route-type.enum';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MobileAuthInstructionComponent } from '../../../../shared/components/mobile-auth-instruction/mobile-auth-instruction.component';
import { LoaderService } from '../../../../core/services/loader.service';
import { IdNotRegisterdInfoComponent } from '../../../user/profile/add-edit-profile-details/id-not-registerd-info/id-not-registerd-info.component';
import { mobileIdPathEnum } from '../../../../core/enums/mobileId-path.enum';
import { SponsorProfile } from '../../../../core/models/sponsor-profile.model';

@Component({
  selector: 'app-family-sign-in',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    ValidationMessageComponent,
    TranslateModule,
    CaptchaComponent,
  ],
  templateUrl: './family-sign-in.component.html',
  styleUrl: './family-sign-in.component.scss'
})
export class FamilySignInComponent {
  sponsorInfoForm!: FormGroup;
  isSubmitted = false;
  signInResponse: any;
  showCaptcha = false;
  showTempSuspendMessage: boolean = false;
  private formSubscription: Subscription | null = null;
  civilIdMaxLimit = globalDatas.CIVIL_ID_MAX_LIMIT;
  civilIDFormat = globalDatas.CIVIL_ID;
  routeType = RouteType;
  civilIdControl = new FormControl('', [Validators.required, Validators.pattern(this.civilIDFormat)
  ]);
  mobileAuthTrackId!: string;
  sponsorPayload!: SponsorProfile;

  constructor(
    public router: Router,
    private _middlewareService: MiddlewareService,
    private encryptionService: EncryptionService,
    private commonService: CommonService,
    private modalService: ModalService,
    protected translateService: TranslateService,
    private ngbModal: NgbModal,
    private loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    localStorage.removeItem('accty');
    this.formSubscription = this.civilIdControl.valueChanges.subscribe((value) => {
      if (this.isSubmitted) {
        this.showCaptcha = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.formSubscription?.unsubscribe();
  }

  onClickSignIn() {
    this.isSubmitted = true;
    if (this.civilIdControl.valid) {
      this.showCaptcha = true;
      // this.initiateAuth();
    }
  }

  initiateAuth() {
    this.isSubmitted = true;
    if (this.civilIdControl.valid) {
      const encryptedPayload = this.encryptionService.encryptData({
        civilId: this.civilIdControl?.value?.toString(),
        mobileIdPath: mobileIdPathEnum.CIVILID_SIGN_IN
      });

      this._middlewareService
        .callPostMiddleware(apiURL.mobileIdAuth, { payload: encryptedPayload })
        .subscribe({
          next: (response: any) => {
            if (response?.code === ApiResponse.OK) {
              if (response?.result?.code === ApiResponse.ERROR) {
                this.modalService.commonAlertModal(this.translateService.currentLang === 'ar' ? response?.result?.arabicMessage : response?.result?.message, ModalType.WARNING);
                return;
              }
              if (response?.result?.Result == 'success') {
                this.mobileAuthTrackId = response?.result?.TrackId;
                const modalRef = this.ngbModal.open(MobileAuthInstructionComponent, {
                  centered: true,
                  size: 'lg',
                  backdrop: 'static',
                });
                modalRef.componentInstance.mobileIdAuthPath = 'civilIdSignIn';
                modalRef.componentInstance.mobileAuthTrackId = this.mobileAuthTrackId;
                modalRef.componentInstance.civilId = this.civilIdControl?.value?.toString();
                modalRef.result.then(
                  (result) => {
                    this.loaderService.showLoader.set(false);
                    if (result && result.message === 'success') {
                      if (result?.response?.civilId) {
                        if (!result?.response?.email) {
                          this.router.navigate([this.routeType.FAMILY_SIGN_UP], { state: { result } });
                          this.modalService.commonAlertModal("ERROR_MESSAGES.SIGN_UP_NOT_COMPLETE", ModalType.WARNING);
                        }
                        else {
                          this.patchValuesToSponsorInfoForm({ ...result?.response, civilId: Number(result?.response.civilId), Gender: result?.response?.Gender === 'M' ? 'Male' : 'Female' });
                        }
                      }
                    } else if (result === 'User is not eligible') {
                      this.ngbModal.open(IdNotRegisterdInfoComponent, {
                        centered: true,
                        size: 'xl',
                        backdrop: 'static',
                      });
                    }
                  });
              } else if (response?.result?.Result == 'fail') {
                this.isSubmitted = true;
                this.modalService.commonAlertModal("CREATE_VISA.CIVIL_ID_INFO.CIVIL_ID_AUTHENTICATION_REJECTED", ModalType.WARNING);
              } else if (response?.result?.Result == 'User is not eligible') {
                this.isSubmitted = true;
                this.ngbModal.open(IdNotRegisterdInfoComponent, {
                  centered: true,
                  size: 'xl',
                  backdrop: 'static',
                });
              } else {
                this.modalService.commonAlertModal("CREATE_VISA.CIVIL_ID_INFO.CIVIL_ID_NOT_MATCHED", ModalType.WARNING);
              }
            }
          },
          error: (error: any) => {
            if (error.status === 400) {
              this.modalService.commonAlertModal("ERROR_MESSAGES.ACCOUNT_DOES_NOT_EXIST", ModalType.WARNING)
            }
            else if (error.status === 409) {
              this.modalService.commonAlertModal("CREATE_VISA.CIVIL_ID_INFO.CIVIL_ID_AUTHENTICATION_CONFLICT", ModalType.WARNING)
            }
            else {
              this.modalService.commonAlertModal("ERROR_MESSAGES.DEFUALT_ERROR", ModalType.WARNING);
            }
          },
        });
    }
  }

  patchValuesToSponsorInfoForm(verifiedPersonDetails) {
    let civilIdExpiryFormat = this.formatDateToYYYYMMDD(verifiedPersonDetails?.CardExpiryDate); // DD/MM/YYYY format
    let dateOfBirthFormat = this.formatDateToYYYYMMDD(verifiedPersonDetails?.BirthDate); // DD/MM/YYYY format
    this.sponsorPayload = {
      profileIdNumber: verifiedPersonDetails?.profileIdNumber,
      dateOfBirth: dateOfBirthFormat,
      civilIdExpiry: civilIdExpiryFormat,
      fullnameAr: verifiedPersonDetails?.FullName,
      fullnameEn: verifiedPersonDetails?.FullNameEn,
      gender: verifiedPersonDetails?.Gender === 'M' ? 'Male' : 'Female',
      passportNationalityAr: verifiedPersonDetails?.Nationality,
      passportNationality: verifiedPersonDetails?.NationalityEn,
      trackId: verifiedPersonDetails?.TrackId,
      civilId: Number(verifiedPersonDetails?.civilId),
      phoneNumberValue: Number(verifiedPersonDetails?.MobileNumber),
      phoneNumberCountryCode: globalDatas.DEFUALT_MOBILE_COUNTRY_CODE.dialCode,
      phoneNumberCountryISO: globalDatas.DEFUALT_MOBILE_COUNTRY_CODE.countryCode,
      mobileIdEmail: verifiedPersonDetails?.EMail,
      governerate: verifiedPersonDetails?.Governerate,
      area: verifiedPersonDetails?.Area,
      paciBuildingNumber: verifiedPersonDetails?.PaciBuildingNumber,
      buildingNumber: verifiedPersonDetails?.BuildingNumber,
      blockNumber: verifiedPersonDetails?.BlockNumber,
      streetNumber: verifiedPersonDetails?.StreetName,
    };
    this.setAuthCookie();
  }

  formatDateToYYYYMMDD(dateString: string): string {
    if (!dateString) return ''; // Handle empty cases
    let date = new Date(dateString);
    let year = date.getFullYear();
    let month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two digits
    let day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
    return `${year}-${month}-${day}`;
  }

  setAuthCookie() {
    const encryptedPayload = this.encryptionService.encryptData({
      civilId: this.sponsorPayload.civilId,
      trackId: this.sponsorPayload.trackId
    });
    if (this.commonService.isBrowser) {
      this._middlewareService
        .callPostMiddleware(`${apiURL.signIn}`, { payload: encryptedPayload })
        .subscribe((response: any) => {
          if (response?.code === ApiResponse.OK) {
            this.showCaptcha = false;
            this.signInResponse = response?.result;
            // Instana user tracking
            const ineum = (window as any).ineum;
            if (typeof ineum === 'function') {
              ineum('meta', 'familyUserEmail', this.signInResponse?.data?.email);
            }
            this.getSelfProfileDetails();
          }
          else if (response?.code === ApiResponse.ERROR) {
            this.showTempSuspendMessage = true;
          }
          else {
            this.showCaptcha = false;
          }
        });
    }

  }

  getSelfProfileDetails() {
    this.commonService.getSelfProfileDetails().subscribe((response) => {
      if (response?.code === ApiResponse.OK) {
        if (response?.result?.data) {
          this.sponsorPayload.profileIdNumber = response?.result?.data?.profileIdNumber;
          localStorage.setItem(
            'xyzACCjsiiyu',
            this.commonService.generateRandomString(20)
          );
          localStorage.setItem('givenName', this.signInResponse?.data?.givenName);
          this.commonService.setAuthenticatedSignal(true);
          if (this.signInResponse?.data?.preferredLanguage) {
            this.commonService.setLanguage(this.signInResponse?.data?.preferredLanguage);
          }
          this.redirectToPage();
        } else {
          this.modalService.commonAlertModal(
            'PROFILE.PROFILE_STATUS_INCOMPLETE_WARNING_MESSAGE',
            ModalType.WARNING
          );
          this.router.navigate([this.routeType.FAMILY_SIGN_UP]);
        }
      }
    });
  }

  redirectToPage() {
    // setTimeout(() => {
    //   window.location.reload();
    // }, 1000);
    this.router.url.includes('evisa-payment') ?
      this.router.navigate([
        this.commonService.getRouteStartIndex() + '/user/application/list',
      ]) :
      this.router.navigate([
        this.commonService.getRouteStartIndex() + '/user/profile',
      ]);
  }

  handleRecaptchaResponse(response: boolean) {
    if (response) {
      this.initiateAuth();
    }
  }

  navigate(url: string) {
    this.router.navigateByUrl(this.commonService.getRouteStartIndex() + url);
  }
}
